import { FC } from 'react';

import { Path, Svg, type SvgProps } from './svg';

export const FlagAltFilled: FC<SvgProps> = (props) => (
	<Svg width={24} height={24} viewBox="0 0 24 24" {...props}>
		<Path
			d="M3.17157 5.17157C3.92172 4.42143 4.93913 4 6 4H21C21.3905 4 21.7453 4.22734 21.9085 4.58214C22.0717 4.93694 22.0134 5.35428 21.7593 5.65079L16.3171 12L21.7593 18.3492C22.0134 18.6457 22.0717 19.0631 21.9085 19.4179C21.7453 19.7727 21.3905 20 21 20H6C4.93913 20 3.92172 19.5786 3.17157 18.8284C2.42143 18.0783 2 17.0609 2 16V8C2 6.93913 2.42143 5.92172 3.17157 5.17157Z"
			fill="currentColor"
		/>
	</Svg>
);
